import Vue from 'vue';

export default (el) =>
  new Vue({
    components: {
      accordion: () => import('../accordion/accordion.vue'),
      'v-style': () => import('../v-style/v-style.vue'),
    },
    el,
  });
